import { render, staticRenderFns } from "./CMSPage.vue?vue&type=template&id=0498de2c&scoped=true&"
import script from "./CMSPage.vue?vue&type=script&lang=js&"
export * from "./CMSPage.vue?vue&type=script&lang=js&"
import style0 from "./CMSPage.vue?vue&type=style&index=0&id=0498de2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498de2c",
  null
  
)

export default component.exports